import React from 'react';
import styled from 'styled-components';
import { InfoBlockLink } from 'Components/InfoBlock';
import { useHeaderContext } from 'Components/HeaderContext';

interface InfoBlockItemProps {
    text: string;
    trackingLabel: string;
    testId?: string;
    url: string;
}

const StyledInfoBlockLink = styled(InfoBlockLink)``;

const InfoBlockItem = ({ text, testId, trackingLabel, url }: InfoBlockItemProps): JSX.Element => {
    const {
        trackingHelpers: {
            ga: { trackNonInteractiveGenericEvent },
        },
    } = useHeaderContext();

    if (url) {
        return (
            <StyledInfoBlockLink
                data-testid={testId}
                href={url}
                onClick={() =>
                    trackNonInteractiveGenericEvent('Header', {
                        action: 'Value propositon click',
                        label: trackingLabel,
                    })
                }
            >
                {text}
            </StyledInfoBlockLink>
        );
    }

    return <span>{text}</span>;
};

export default InfoBlockItem;
